import { IS_LOCAL } from '@/helpers';
import i18n from '@/plugins/i18n';

/**
 * @description 에러 모달 오픈
 */
function openErrModal(errModal, e) {
  console.error(e);

  errModal.open({
    // 오류가 발생했습니다.
    title: e.response?.data?.message?.title ?? i18n.t('etc.modalerr'),
    content: e.response?.data?.message?.content ?? e.response?.data?.message?.replaceAll('|', '<br />') ?? e,
    cancel: false,
  });
}

const IceCreamStore = {
  namespaced: true,
  state() {
    return {
      /** 데일리 미션 상태 */
      dailyMissionStatus: {
        attendance: 1,
        invite: 0,
        subs: 0,
        rentalIncome: 0,
        swap: 0,
        nft: 0,
      },
      /** 아이스크림 게임 상태 */
      iceCreamGameStatus: {
        isOngoing: false, // 게임 진행 중인지
        coin: 0, // 내가 모은 동전
        shape: null, // 진행 중인 아이스크림 모양
        angle: null,
      },
      /** 아이스크림 세트 상태 */
      iceCreamSetStatus: {},
      /** 아이스크림 세트 상세 내역 */
      iceCreamSetDetail: [],
    };
  },
  getters: {},
  mutations: {
    setDailyMissionStatus(state, status) {
      state.dailyMissionStatus = { ...status };
      state.dailyMissionStatus.attendance = 1;
    },
    setIceCreamGameStatus(state, status) {
      state.iceCreamGameStatus = { ...status };
    },
    setIceCreamSetStatus(state, status) {
      state.iceCreamSetStatus = { ...status };
    },
    setIceCreamSetDetail(state, detail) {
      state.iceCreamSetDetail = detail;
    },
  },
  actions: {
    /**
     * @description API 호출
     */
    async fetch({ rootState: { vm, globalErrorModal } }, { url, method, params }) {
      const data = method === 'get' ? { params: { ...params } } : params;

      try {
        const { data: responseData } = await this._vm.$axios[method](
          `${process.env.VUE_APP_TEST_SERVER}${'/ice-cream' + url}`,
          data
        );
        return responseData;
      } catch (e) {
        if (e?.response?.status === 401) vm.$bvModal.show('login-required');
        else openErrModal(globalErrorModal, e);

        throw e;
      }
    },
    /**
     * @description 아이스크림 미션 현황 조회
     */
    async getDailyMissionStatus({ dispatch }) {
      if (IS_LOCAL) {
        return {
          attendance: 1,
          invite: 1,
          subs: 3,
          rentalIncome: 0,
          swap: 1,
          nft: 1,
        };
      }

      const response = await dispatch('fetch', {
        method: 'get',
        url: '/mission/status',
      });

      return response;
    },
    /**
     * @description 아이스크림 미션 현황 업데이트
     */
    async fetchDailyMissionStatus({ dispatch, commit }) {
      console.log('fetchDailyMissionStatus');
      const missionStatus = await dispatch('getDailyMissionStatus');

      commit('setDailyMissionStatus', missionStatus);
      return;
    },
    /**
     * @description 아이스크림 게임 상태 조회
     */
    async getIceCreamGameStatus({ dispatch }) {
      if (IS_LOCAL) {
        return {
          isOngoing: false, // 게임 진행 중인지
          coin: 25, // 내가 모은 동전
          flavor: 'pistachio', // 뽑은 맛
          choosed: [0, 3], // 몇 번째 맛을 뽑았었는지
        };
      }

      const response = await dispatch('fetch', {
        method: 'get',
        url: '/game/status',
      });

      return response;
    },
    /**
     * @description 아이스크림 게임 상태 업데이트
     */
    async fetchIceCreamGameStatus({ dispatch, commit }) {
      console.log('fetchIceCreamGameStatus');
      const gameStatus = await dispatch('getIceCreamGameStatus');

      commit('setIceCreamGameStatus', gameStatus);
      return;
    },
    /**
     * @description 아이스크림 세트 상태 조회
     */
    async getIceCreamSetStatus({ dispatch }) {
      if (IS_LOCAL) {
        return {
          status: [4, 8, 1, 4], // circle, triangle, star, umbrella 순서
          completed: 2, // 나의 완성 세트 수
        };
      }

      const response = await dispatch('fetch', {
        method: 'get',
        url: '/set/status',
      });

      return response;
    },
    /**
     * @description 아이스크림 세트 상태 업데이트
     */
    async fetchIceCreamSetStatus({ dispatch, commit }) {
      console.log('fetchIceCreamSetStatus');
      const setStatus = await dispatch('getIceCreamSetStatus');

      commit('setIceCreamSetStatus', setStatus);
      return;
    },
    /**
     * @description 아이스크림 세트 상세 내역 조회
     */
    async getIceCreamSetDetail({ dispatch }) {
      if (IS_LOCAL) {
        return [
          {
            date: '2024-03-22T17:34:23',
            content: '출석체크 완료',
            value: 1,
          },
        ];
      }

      const response = await dispatch('fetch', {
        method: 'get',
        url: '/set/history',
      });

      return response;
    },
    /**
     * @description 아이스크림 세트 상세 내역 업데이트
     */
    async fetchIceCreamSetDetail({ dispatch, commit }) {
      console.log('fetchIceCreamSetDetail');
      const setDetail = await dispatch('getIceCreamSetDetail');

      commit('setIceCreamSetDetail', setDetail);
      return;
    },
    /**
     * @description 아이스크림 뽑기
     */
    async postIceCreamFlavor({ dispatch }, { index }) {
      if (IS_LOCAL) {
        return {
          coin: 25, // 내가 모은 동전
          flavor: 'pistachio', // 뽑은 맛
          choosed: [3], // 몇 번째 맛을 뽑았었는지
        };
      }
      const response = await dispatch('fetch', {
        method: 'post',
        url: '/game/draw',
        params: {
          index: index, // 0부터 시작
        },
      });

      return response;
    },
    /**
     * @description 아이스크림 뽑기
     */
    async submitIceCreamFlavor({ dispatch }, { index }) {
      console.log('submitIceCreamFlavor');
      const result = await dispatch('postIceCreamFlavor', { index });

      return result;
    },
    /**
     * @description 아이스크림 보상 받기
     */
    async postIceCreamReward({ dispatch }) {
      if (IS_LOCAL) {
        return {
          result: 'success',
        };
      }
      const response = await dispatch('fetch', {
        method: 'post',
        url: '/game/reward',
      });

      return response;
    },
    /**
     * @description 아이스크림 보상 받기
     */
    async submitIceCreamReward({ dispatch }) {
      console.log('submitIceCreamReward');
      const result = await dispatch('postIceCreamReward');

      return result;
    },
    /**
     * @description 아이스크림 세트 보상 받기
     */
    async postIceCreamSetReward({ dispatch }) {
      if (IS_LOCAL) {
        return '';
      }
      const response = await dispatch('fetch', {
        method: 'post',
        url: '/set/reward',
      });

      return response;
    },
    /**
     * @description 아이스크림 세트 보상 받기
     */
    async submitIceCreamSetReward({ dispatch }) {
      console.log('submitIceCreamSetReward');
      const result = await dispatch('postIceCreamSetReward');

      return result;
    },
    /**
     * @description 아이스크림 이벤트 클로버 사용
     */
    async postIceCreamGameClover({ dispatch }) {
      if (IS_LOCAL) {
        return '';
      }
      const response = await dispatch('fetch', {
        method: 'post',
        url: '/clover/use',
      });

      return response;
    },
    /**
     * @description 아이스크림 이벤트 클로버 사용
     */
    async submitIceCreamGameClover({ dispatch }) {
      console.log('submitIceCreamGameClover');
      const result = await dispatch('postIceCreamGameClover');

      return result;
    },
  },
};

export default IceCreamStore;
